import { render } from "./AboutTab.vue?vue&type=template&id=14dbe09c"
import script from "./AboutTab.vue?vue&type=script&lang=js"
export * from "./AboutTab.vue?vue&type=script&lang=js"

import "./AboutTab.vue?vue&type=style&index=0&id=14dbe09c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__